import { mergeClasses } from '@blank/utilities'
import { Illustration } from 'modules/common/components/Illustrations/Illustration'
import { IconArrowLeft } from 'modules/common/components/_icons/icons'
import { Button } from 'modules/common/components/_ui/Button/Button'
import { IllustrationName } from 'modules/common/types/illustrations'
import { Trans } from 'next-i18next'
import { PropsWithChildren } from 'react'

export interface MandatoryInformationCardProps {
  goBack?: () => void
  illustrationName?: IllustrationName
  title?: string
  subtitle?: string
  className?: string
}
export const MandatoryInformationCard = ({
  goBack,
  illustrationName,
  title,
  subtitle,
  children,
  className,
}: PropsWithChildren<MandatoryInformationCardProps>) => {
  return (
    <div className={mergeClasses('flex flex-col gap-6', className)}>
      {goBack && (
        <div className={illustrationName && 'absolute z-10'}>
          <Button
            variant="none"
            onClick={goBack}
            icon={<IconArrowLeft className="h-8 w-8" />}
          />
        </div>
      )}
      {illustrationName && (
        <div className="flex w-full justify-center">
          <Illustration name={illustrationName} size="l" />
        </div>
      )}
      {title && (
        <Trans parent="h1" className="text-center">
          {title}
        </Trans>
      )}
      {subtitle && (
        <Trans parent="p" className={mergeClasses({ 'mt-2': title })}>
          {subtitle}
        </Trans>
      )}
      {children}
    </div>
  )
}
